import { request } from './request';
import { encrypt } from '@/utils/crypto';

interface UpdateUserParams {
  name?: string;
  birthday?: string;
  nationality?: string;
  roleId: number
}
// 登录请求参数
export interface LoginParams {
  username: string;
  password: string;
  clientType: string;
  scope: string;
  loginType: string;
}

// 登录响应数据
export interface LoginResponse {
  accessToken: string;
  lincId: string;
}

// 用户信息响应
export interface UserInfoResponse {
  id: string;
  username: string;
  email: string;
  name?: string;
  avatar?: string;
  enterpriseId?: string;
  permissions?: string[];
  roleInfo?: {
    name?: string;
    id: number
  };
  [key: string]: any; // 允许其他字段
}

// 登录接口
export function loginApi(params: { username: string; password: string }): Promise<LoginResponse> {
  // 加密密码
  const encryptedPassword = encrypt(params.password);
  
  return request({
    url: '/id-auth/api/v1/login',
    method: 'POST',
    data: {
      username: params.username,
      password: encryptedPassword,
      clientType: 'linc-retention-support',
      scope: 'user.r',
      loginType: 'password_login'
    }
  });
}

// 获取用户信息接口
export function getUserInfoApi(): Promise<UserInfoResponse> {
  return request({
    url: '/id-auth/api/v1/rs-account/info',
    method: 'GET'
  });
}
// 获取用户信息接口
export function updateUserInfoApi(id: string, params: UpdateUserParams): Promise<UserInfoResponse> {
  return request({
    url: `/rs-enterprise/api/v1/account/${id}`,
    method: 'PUT',
    data: params
  });
}

// 登出接口
export function logoutApi(): Promise<void> {
  return request({
    url: '/id-auth/api/v1/logout',
    method: 'POST'
  });
}

// 忘记密码接口
export function forgotPasswordApi(email: string): Promise<void> {
  return request({
    url: '/id-auth/api/v1/password-reset/request',
    method: 'POST',
    data: {
      email
    }
  });
}

// 确认密码重置接口
export function confirmPasswordResetApi(params: { token: string; newPassword: string }): Promise<void> {
  // 加密密码
  const encryptedPassword = encrypt(params.newPassword);
  
  return request({
    url: '/id-auth/api/v1/password-reset/confirm',
    method: 'POST',
    data: {
      token: params.token,
      newPassword: encryptedPassword
    }
  });
}

